<template>
  <div class="page">
    <div class="home-group">
      <van-tabs v-model="active" :animated="enableAnimate" swipeable>
        <van-tab v-for="item in cList" :key="item.text">
          <component class="home-group-item" :is="item.component"></component>
        </van-tab>
      </van-tabs>
    </div>

    <van-tabbar v-model="active" :fixed="false">
      <van-tabbar-item
        class="tabbar"
        v-for="(item, index) in cList"
        :class="index == active ? 'active' : 'inactive'"
        :key="item.text"
      >
        {{ item.text }}
        <template #icon>
          <svg class="vxm-icon" aria-hidden="true" size="26">
            <use
              :xlink:href="'#vxm-icon-' + (index === active ? item.activeIcon : item.icon)"
            ></use>
          </svg>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Home1 from './child/home1.vue';
import Home2 from '../mall/list.vue';
import Home3 from './child/home3.vue';

export default {
  name: 'home',
  components: {
    Home1,
    Home2,
    Home3,
  },
  mixins: [app.mixin.share],
  computed: {
    ...Vuex.mapState(['userInfo']),
  },
  data() {
    return {
      pageTitle: '主页',
      active: parseInt(this.$vxRoute.params.active),
      enableAnimate: false,
      cList: [
        {
          text: '主页',
          pageTitle: '主页',
          icon: 'home_default',
          activeIcon: 'home_focus',
          component: Home1,
        },
        {
          text: '商城',
          pageTitle: '商城',
          icon: 'gk_default',
          activeIcon: 'gk_focus',
          component: Home2,
        },
        {
          text: '我的',
          icon: 'me2_default',
          activeIcon: 'me2_focus',
          component: Home3,
        },
      ],
    };
  },
  mounted() {
    this.enableAnimate = true;
    // 设置分享
    this.app_share_resolve({
      title: '一部手机管理一个机构',
      desc: '',
      link: location.href,
      imgUrl: `https://cdn01.xiaogj.com/file/02f7ff5c926b4a97a903f7026bbde3c6/202007/fa57ceffb91949bc911468e163a13c95.png`,
    });

    // if (this.userInfo.companyAppOpenList.indexOf("WALLET")<0) { //如果机构未开通收费管家则不显示购课菜单
    //   this.cList.splice(1,1)
    // }
    // const showMall = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'MALL_PORTAL' && item.openStatus == 1) : true;
    // if (this.userInfo.isOpenMerchant === 0 || !showMall) {
    //   //如果机构未开通收费管家则不显示购课菜单
    //   this.cList.splice(1, 1);
    // }
    // 如果机构未打开家长端商城菜单功能则不显示
    const showMall = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'MALL_PORTAL' && item.openStatus == 1) : true;
    if (!showMall) {
      this.cList.splice(1, 1);        
    }
  },
  watch: {
    userInfo() {
      let c = this.cList[this.active || 0];
      this.pageTitle = this.userInfo.companyName || c.pageTitle || c.text;
      app.tool.setDocTitle(this.userInfo.companyName);
    },
    active: {
      immediate: true,
      handler(nv, ov) {
        let c = this.cList[this.active || 0];
        this.pageTitle = this.userInfo.companyName || c.pageTitle || c.text;
        app.tool.setDocTitle(this.userInfo.companyName || this.pageTitle);

        if (ov !== undefined) {
          this.$router.replace({
            params: {
              active: nv,
            },
            query: this.$vxRoute.query,
          });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-tabs {
  height: 100%;
  .van-tabs__wrap {
    display: none;
  }
  .van-tabs__content {
    height: 100%;
  }
}
.page {
  display: flex;
  flex-direction: column;
}
.home-group {
  flex: 1;
  .home-group-item {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 1;
  }
}
.tabbar {
  font-size: var(--fs-xs);
  &.active {
    color: var(--c1);
  }
  &.inactive {
    color: var(--g6);
  }
}
</style>